import React  from 'react';
import { Redirect } from '@reach/router';
import Global from '../../clients/global'

const Home = () => {
  return <Redirect to={`/zone/${Global.zoneid}}`} noThrow />;
};

export default Home;
